import { createIcon, Path } from './index';

export const IconBriefcaseWhite = createIcon({
  title: 'A briefcase',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M26.667 9.33331H5.33366C3.8609 9.33331 2.66699 10.5272 2.66699 12V25.3333C2.66699 26.8061 3.8609 28 5.33366 28H26.667C28.1398 28 29.3337 26.8061 29.3337 25.3333V12C29.3337 10.5272 28.1398 9.33331 26.667 9.33331Z"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M21.3337 9.33331V6.66665C21.3337 5.95417 21.0504 5.27082 20.5503 4.77072C20.0502 4.27062 19.3668 3.98731 18.6544 3.98731H13.3464C12.6339 3.98731 11.9506 4.27062 11.4505 4.77072C10.9504 5.27082 10.667 5.95417 10.667 6.66665V9.33331"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
